<script>
import Vue from "vue";
import VTooltip from "v-tooltip";
Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import "v-tooltip/dist/v-tooltip.css";
import Loader from "@/components/widgets/loader";

export default {
    mixins: [Api, Sabit],
    props: ["UstDonemId", "DonemId","Sorgulama", "TabloId"],
    components: {
        Loader
    },
    data() {
        return {
            Page: {
                PageNumber: "1",
                PageSize: "9999",
                PageDataSize: "1",
                
            },
            TableData: {},
            unibirim: {},
            DonemAdi: "",
            loading: true,
            uri: "data:application/vnd.ms-excel;base64,",
            template: '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
            base64: function (s) {
                return window.btoa(unescape(encodeURIComponent(s)));
            },
            format: function (s, c) {
                return s.replace(/{(\w+)}/g, function (m, p) {
                    return c[p];
                });
            },
        };
    },
    watch: {
        DonemId() {
            this.Get();
        },
                TabloId() {
            this.Get();
        },
    },
    methods: {
        groupBy: function (array, key) {
            const result = {};
            array.forEach((item) => {
                if (!result[item[key]]) {
                    result[item[key]] = [];
                }
                result[item[key]].push(item);
            });
            return result;
        },
        Get() {

            let Filter = "&DonemId=" + this.DonemId + "&UstDonemId=" + this.UstDonemId + "&TabloId=" + this.TabloId;
            this.ActionsFilterGet({ Service: "StrRaporlama/GetKurumBirimHedefGerceklesmeKarsilastirmaTablosu", Page: this.Page, Filter: Filter }).then((res) => {
                this.TableData = res.Data;

            });
        },
        Fark(Data){
            var Fark = 0;
            if(Data){
              Fark = Data.Universitehedefi - Data.Birimbazlihedeftoplam  
            }
            return Fark;
        },
        formatNumber(value) {
  if (typeof value !== "number") return value;
  return value.toLocaleString("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
},
        getColor(birimlerHedefToplam, uniHedef) {
        const fark = birimlerHedefToplam - uniHedef;
    if (fark > 0) {
        return "rgba(144, 238, 144, 0.5)"; 
      } else if (fark < 0) {
        return "rgba(255, 99, 71, 0.5)"; 
      } else {
        return "rgba(211, 211, 211, 0.5)"; 
      }
        },
ExcelExport(tableId, name) {
  this.$nextTick(() => {
    let table = this.$refs.veriGiris;
    if (!table) return;

    let html = table.innerHTML;

    // writing-mode içeren tüm hücre stillerini Excel'e özel mso-rotate'a dönüştür
    html = html.replace(/style="[^"]*?writing-mode:\s?vertical-rl;[^"]*?"/g, styleStr => {
      return styleStr.replace(/style="/, 'style="mso-rotate:90; height:150px; ');
    });

    const ctx = { worksheet: name || 'Worksheet', table: html };
    const a = document.createElement('a');
    a.href = this.uri + this.base64(this.format(this.template, ctx));
    a.download = name + '.xls';
    a.click();
  });
}



    },

    computed: {},
    created() {
        this.Get();
                    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };

    this.ActionsFilterGet({ Service: "OBirim", Page: Page, Filter: "&BirimTipAdi=Üniversite"}).then(
      (res) => {
 this.unibirim = res.Data[0].BirimAdi
      }
    );
    },
};
</script>
<template>
    <Loader>
        <div>
            <div class="text-sm-end">
                <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="
                    ExcelExport(
                        'BirimBazlıHedefToplamlarıTablosu',
                        'BirimBazlıHedefToplamlarıTablosu',
                    )
                ">
                    <i class="mdi mdi-file-export-outline me-1"></i>
                    Excel'e Aktar
                </button>
            </div>
            <div ref="veriGiris" class="table-responsive">
                <div class="table-responsive">
                    <br>
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="table-responsive">
                                 <table class="table-bordered col-md-12">
    <thead>
        <tr style="background-color:rgb(182, 221, 232); border-color:white; border-style: solid; text-align: center; height: 50px;" rowspan="1">
            <th class="col-md-12" :colspan="TableData[0].gostergeler[0].birimler.length * 2 + 5">Birim Hedef / Birim Gerçekleşme Karşılaştırma Tablosu</th>
        </tr>
    </thead>
    <thead>
        <tr style="background-color:rgb(182, 221, 232); border-color:white; border-style: solid; text-align: center; height: 50px;" rowspan="1">
            <th colspan="1" style="max-width: 250px;">Dönem Adı</th>
            <th :colspan="(TableData[0].gostergeler[0].birimler.length * 2 + 4)">{{TableData[0].donem}}</th>
        </tr>
        <tr style="background-color:rgb(182, 221, 232); border-color:#e0e0e0; border-style: solid; text-align: center; height: 50px;" rowspan="1">
            <th colspan="1">Tablo Adı</th>
            <th :colspan="(TableData[0].gostergeler[0].birimler.length * 2 + 4)">{{TableData[0].tablo}}</th>
        </tr>
        <tr style="background-color:rgb(182, 221, 232); border-color:white; border-style: solid; text-align: center; height: 50px;" rowspan="1">
            <th colspan="1" rowspan="2">Gösterge</th>
            <th rowspan="1" :colspan="TableData[0].gostergeler[0].birimler.length * 2">Birim Hedef ve Gerçekleşmeleri</th>
            <th colspan="1" rowspan="2" style="writing-mode: vertical-rl; transform: rotate(180deg); text-align: center; white-space: normal; word-break: break-word; height: auto; vertical-align: middle; padding: 10px;">Birim Hedef Toplamı</th>
            <th colspan="1" rowspan="2" style="writing-mode: vertical-rl; transform: rotate(180deg); text-align: center; white-space: normal; word-break: break-word; height: auto; vertical-align: middle; padding: 10px;">Birim Gerçekleşme Toplamı</th>
            <th colspan="1" rowspan="2" style="writing-mode: vertical-rl; transform: rotate(180deg); text-align: center; white-space: normal; word-break: break-word; height: auto; vertical-align: middle; padding: 10px;">{{unibirim}} Hedefi</th>
            <th colspan="1" rowspan="2" style="writing-mode: vertical-rl; transform: rotate(180deg); text-align: center; white-space: normal; word-break: break-word; height: auto; vertical-align: middle; padding: 10px;">{{unibirim}} Hedef / Birim Gerçekleşme Olumlu/Olumsuz Fark</th>
        </tr>
        <tr style="background-color:rgb(182, 221, 232); border-color:#e0e0e0; border-style: solid; text-align: center; height: 50px;" rowspan="1">
            <th v-for="(birim, index) in TableData[0].gostergeler[0].birimler" :key="index" colspan="2"  :style="`writing-mode: vertical-rl; border-right: 5px solid #e0e0e0 !important; transform: rotate(180deg); text-align: center; white-space: normal; word-break: break-word; height: auto; vertical-align: middle; padding: 10px;`">
                {{ birim.birim }}
            </th>

        </tr>
        <tr style="background-color:rgb(182, 221, 232); border-color:#e0e0e0; border-style: solid; text-align: center; height: 50px;" rowspan="1">
            <th></th>
            <template v-for="(birim, index) in TableData[0].gostergeler[0].birimler">
                <th :key="`h-${index}`" style=" text-align: center;">H</th>
                <th :key="`g-${index}`" style="border-right: 5px solid #e0e0e0 !important; text-align: center;">G</th>
            </template>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
        </tr>
    </thead>
    <tbody v-for="(Data, index) in TableData[0].gostergeler" :key="index">
        <tr style="text-align: center">
            <th colspan="1">{{ Data.gosterge }}</th>
            <template v-for="(birim, bIndex) in Data.birimler">
                <td :key="`h-${index}-${bIndex}`" >
                    <span v-if="birim.birimHedef !== -1">{{formatNumber(birim.birimHedef)}}</span>
                    <span v-else></span>
                </td>
                <td :key="`g-${index}-${bIndex}`" style="border-right: 5px solid #e0e0e0  !important;">
                    <span v-if="birim.birimGerceklesme !== -1">{{  formatNumber(birim.birimGerceklesme) }}</span>
                    <span v-else></span>
                </td>
            </template>
            <td>
                <span v-if="Data.birimlerHedefToplam !== -1">{{ Data.birimlerHedefToplam }}</span>
                <span v-else></span>
            </td>
            <td>
                <span v-if="Data.birimlerGerceklesmeToplam !== -1">{{ Data.birimlerGerceklesmeToplam }}</span>
                <span v-else></span>
            </td>
            <td>
                <span v-if="Data.uniHedef !== -1">{{ Data.uniHedef }}</span>
                <span v-else></span>
            </td>
            <td v-if="Data.uniHedef !== -1" :style="'background:' + Data.renk">
                <span style="color: white;">{{ Data.birimlerGerceklesmeToplam - Data.uniHedef }}</span>
            </td>
            <td v-else></td>
        </tr>
    </tbody>
</table>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
</Loader>
</template>
<style>
td {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
}

</style>
